import * as Yup from 'yup';

export const schema = Yup.object().shape({
  airportName: Yup.string().required('Required'),
  atisVersion: Yup.string()
    .required('Required')
    .min(1, 'Must be set'),
});
